<template>
	<DashCard
		title="Lead Health"
		:loading="loading"
		:has-error="hasError"
		:no-data="noLoadedData"
		:info-data="infoData"
		@reload="$emit('reload', 'lead_health')"
	>
		<template #icon><LeadHealthIcon /></template>

		<div class="card-content" :class="isMobileView && 'card-content--mobile'">
			<div class="item-wrapper">
				<span class="with-currency item-data">{{ formatMoney(computedData.apvPerLead) }}</span>
				<span class="item-label">APV Per Lead</span>
			</div>
			<div class="item-wrapper">
				<span class="item-data">{{ formatRatio(computedData.leadCostProfit) }}%</span>
				<span class="item-label">Lead Cost % of Profit</span>
			</div>
		</div>
	</DashCard>
</template>

<script>
import DashCard from '../DashCard.vue'
import LeadHealthIcon from '../../Icons/LeadHealthIcon.vue'

const getData = (data, period) => ({
	apvPerLead: data[`apv_per_lead_${period}`],
	leadCostProfit: data[`lead_cost_profit_${period}`],
})

export default {
    components: {
		DashCard,
		LeadHealthIcon,
	},
	props: {
		data: {
			type: Object,
			default: null,
		},
		monthlyPeriod: {
			type: Boolean,
			default: true,
		},
		infoData: Object,
	},
    computed: {
		isMobileView () {
			return this.$vuetify.breakpoint.xs
		},
		loading () {
			if (!this.data) { return false }
			return this.data.loading
		},
		hasError () {
			if (!this.data) { return false }
			return this.data.error
		},
		noLoadedData () {
			if (this.data && this.data.loaded) {
				if (!this.data.data) { return true }
				return Object.values(this.data.data).every(this.checkNullish)
			}
			return false
		},
		computedData () {
			const data = this.data?.data || {}
			const monthly = getData(data, 'monthly')
			const weekly = getData(data, 'weekly')
			return this.monthlyPeriod ? monthly : weekly
		},
    },
	methods: {
		checkNullish (value) {
			return [undefined, null, ''].includes(value)
		},
		formatMoney (value) {
			if (this.checkNullish(value)) { return 'NA' }
			return this.formatNumber(value, '(0,0.00)')
		},
		formatRatio (value) {
			if (this.checkNullish(value)) { return 'NA' }
			return this.formatNumber(100 * value, '(0)')
		},
	},
}
</script>

<style lang="scss" scoped>
@import '../../style/index.scss';

$block: card-content;

.#{$block} {
	--font-size: 1.5rem;
	--font-size-label: 0.8rem;

	&--mobile {
		--font-size: 1.2rem;
		--font-size-label: 0.8rem;
	}

	height: 100%;
	width: 100%;
	padding-top: 1.25rem;
	display: flex;
	gap: 2rem;
	color: $color-text;

	.item-wrapper {
		display: flex;
		flex-direction: column;
		flex-basis: 0;
		flex-grow: 1;
	}

	.item-data {
		line-height: 1;
		font-size: var(--font-size);
	}

	.item-label {
		margin-top: 0.25rem;
		font-size: var(--font-size-label);
		font-weight: bold;
		line-height: 1.25;
	}
}
</style>
